import PropTypes from "prop-types";
import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { getAuthProps } from "../services";
import { redirectToPortal, isNavigationPathAllowed, getFirstNavigationPath } from "../utils";

const ProtectedRoute = ({ children, sidebarMenuConfig, loginPath }) => {

  const authData = getAuthProps();
  const isLogedin = !!authData;
  const isAuthenticated = !!authData;
  const location = useLocation();
  const navigate = useNavigate();

  const isAllowed = !sidebarMenuConfig ||
    !Array.isArray(sidebarMenuConfig) ||
    sidebarMenuConfig.length === 0 ||
    isNavigationPathAllowed(location.pathname, sidebarMenuConfig);

  useEffect(() => {
    if (isLogedin && isAuthenticated && !isAllowed) {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        const defaultPath = getFirstNavigationPath(sidebarMenuConfig) || "/dashboard";
        navigate(defaultPath, { replace: true });
      }
    }
  }, [isLogedin, isAuthenticated, isAllowed, location.pathname, sidebarMenuConfig, navigate]);

  if (!isLogedin && !isAuthenticated) {
    // Apps with their own login page (e.g. placement company login) pass an in-app path
    if (loginPath) {
      return <Navigate to={loginPath} replace />;
    }
    window.location.href = redirectToPortal(authData?.isErpLoggedIn, "/login");
    return null;
  }

  if (!isAllowed) {
    return null;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  sidebarMenuConfig: PropTypes.array,
  loginPath: PropTypes.string,
};

export default ProtectedRoute;

